import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import UpcomingDueCustomers from './UpcomingDueCustomers';
import InstallmentSummaryCards from './InstallmentSummaryCards';
import GreetingHeader from './GreetingHeader';
import TargetProgress from '../common/TargetProgress';
import UserBadge from '../common/UserBadge';
import EcgHeartbeat from '../common/EcgHeartbeat';
import { Users, Package } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DataEntryDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/dashboard/data-entry-stats`, { withCredentials: true })
      .then(({ data }) => setStats(data))
      .catch(() => setStats({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96 text-slate-400">Loading dashboard...</div>;

  const cards = [
    { title: 'Branch Customers', value: stats?.my_customers || 0, icon: Users, color: 'text-blue-500', testId: 'de-stat-customers' },
    { title: 'Added Today (Branch)', value: stats?.my_customers_today || 0, icon: Users, color: 'text-emerald-500', testId: 'de-stat-today' },
    { title: 'My Additions (This Month)', value: stats?.my_customers_month || 0, icon: Users, color: 'text-amber-500', testId: 'de-stat-month' },
    { title: 'Branch Inventory', value: stats?.my_inventory || 0, icon: Package, color: 'text-purple-500', testId: 'de-stat-inventory' },
  ];

  return (
    <div className="space-y-6" data-testid="data-entry-dashboard">
      <GreetingHeader
        testId="de-greeting"
        fallbackName="Data Entry Officer"
        subtitle="Data Entry Dashboard · Track your onboarding and inventory data-entry productivity"
        extra={<UserBadge badge={stats?.badge} testId="de-user-badge" />}
      />
      <TargetProgress
        target={stats?.monthly_target || 0}
        current={stats?.my_customers_month || 0}
        testId="de-target-progress"
      />
      <EcgHeartbeat testIdPrefix="de" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <Card key={i} className="bg-slate-900 border-slate-800 hover:-translate-y-1 transition-transform" data-testid={c.testId}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-slate-400">{c.title}</CardTitle>
              <c.icon className={`h-4 w-4 ${c.color}`} />
            </CardHeader>
            <CardContent><div className="text-2xl font-bold text-white">{c.value}</div></CardContent>
          </Card>
        ))}
      </div>
    <InstallmentSummaryCards />
      <UpcomingDueCustomers />

    </div>
  );
}
